/** Characters a folder may contain: nothing a shell would read (', ", `, $, ;, &, |, <, >, %, newlines). */
const SAFE_POSIX = /^[A-Za-z0-9 _\-.()+,@/~]+$/;
const SAFE_WINDOWS = /^[A-Za-z]:\\[A-Za-z0-9 _\-.()+,@\\]*$/;
export const MAX_INSTALL_DIR = 200;
function segmentsProblem(segments, example) {
    if (segments.length === 0)
        return `Name a folder, not the top of the disk — for example ${example}`;
    if (segments.some((s) => s === '..' || s === '.'))
        return 'No . or .. in the path — write the full folder';
    return null;
}
/**
 * Doc 49: an install folder the shell line can carry safely. macOS (and Linux): `/…` or `~/…`; Windows: `X:\…`
 * on a local drive. Returns the folder without trailing separators, or why it cannot be used.
 */
export function checkInstallDir(os, raw) {
    const value = raw.trim();
    if (value.length > MAX_INSTALL_DIR)
        return { problem: `At most ${MAX_INSTALL_DIR} characters` };
    if (os === 'windows') {
        if (!/^[A-Za-z]:\\/.test(value))
            return { problem: 'Use a full path on a drive of this PC, for example D:\\Couch (no network shares)' };
        if (!SAFE_WINDOWS.test(value))
            return { problem: 'Only letters, digits, spaces and _ - . ( ) + , @ are allowed in the folder names' };
        const dir = value.replace(/\\+$/, '');
        const problem = segmentsProblem(dir.slice(3).split('\\').filter(Boolean), 'D:\\Couch');
        return problem ? { problem } : { dir };
    }
    if (!value.startsWith('/') && !value.startsWith('~/'))
        return { problem: 'Use a full path, for example /Volumes/T7/Couch or ~/Couch' };
    if (!SAFE_POSIX.test(value) || value.indexOf('~', 1) >= 0)
        return { problem: 'Only letters, digits, spaces and _ - . ( ) + , @ are allowed in the folder names' };
    const dir = value.replace(/\/+$/, '');
    const problem = segmentsProblem(dir.replace(/^~/, '').split('/').filter(Boolean), '/Volumes/T7/Couch');
    return problem ? { problem } : { dir };
}
//# sourceMappingURL=install-dir.js.map